const cache = new Map();

export function getSheet(url) {
    if (!cache.has(url)) {
        cache.set(url, fetch(url).then(r => r.text()).then(css => {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(css);
            return sheet;
        }));
    }
    return cache.get(url);
}

export function preloadSheets(urls) {
    urls.forEach(getSheet);
}

export async function applySheets(shadowRoot, urls) {
    const sheets = await Promise.all(urls.map(getSheet));
    shadowRoot.adoptedStyleSheets = sheets;
}